import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { NgIf, NgFor, CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { GridService } from 'app/services/grid.service';
import { SVGIcon, trashIcon} from '@progress/kendo-svg-icons';
import { MatIconModule } from '@angular/material/icon';
import { AuthService } from 'app/core/auth/auth.service';



@Component({
  selector: 'app-new-chat-modal',
  templateUrl: './new-chat-modal.component.html',
  styleUrls: ['./new-chat-modal.component.scss'],
  standalone: true, // Indica che è un componente standalone
  imports: [
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    ReactiveFormsModule,
    NgIf,
    NgFor,
    MatSelectModule,
    MatIconModule,
    CommonModule
  ]
})
export class NewChatModalComponent implements OnInit {
  chatForm: FormGroup;
  usersList: any[] = []; // Array per memorizzare gli utenti recuperati dall'API
    user: any;
  constructor(
    private fb: FormBuilder,
    private gridService: GridService,
    private authService: AuthService, // Il servizio per recuperare gli utenti
    public dialogRef: MatDialogRef<NewChatModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.chatForm = this.fb.group({
      title: ['', Validators.required],
      chatUsers: this.fb.array([])
    });
  }

  ngOnInit(): void {
    // Recupera gli utenti tramite l'API
    this.user = this.authService.user
    this.gridService.getDropDownValues("CHATS.User").subscribe((users) => {
      this.usersList = users;
      this.usersList = this.usersList.filter( u => u.value != this.user.id);

    });
  }

  get chatUsers(): FormArray {
    return this.chatForm.get('chatUsers') as FormArray;
  }

  addChatUser(): void {
    this.chatUsers.push(this.fb.group({
      userId: ['', Validators.required] // Usa userId per memorizzare l'ID dell'utente
    }));
  }

  removeChatUser(index: number): void {
    this.chatUsers.removeAt(index);
  }

  save(): void {
    if (this.chatForm.valid) {
      this.dialogRef.close(this.chatForm.value);
    }
  }

  userIdInArray(userId: any): boolean{
    var chatUserId = this.chatUsers.value.map(c => c.userId);
    if(chatUserId.includes(userId))
        return true;
    else
        return false;
  }

  close(): void {
    this.dialogRef.close();
  }
}
